module.exports = __webpack_public_path__ + "purplecircle.6d22390b.png";